import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from "react-redux";
import { START_DATE } from 'react-dates/constants';
import { useParams } from "react-router";
import moment from 'moment';
import Calendar from '../../../Units/Calendar';
import Dropdown from "../../../Units/DropDown";
import Header from "../../components/Header";
import PlayerRow from "./PlayerRowTransfer";
import GameTransferRow from "./GameTransferRow";
import { requestClubTransfers, requestGameTransfers } from "../../../../store/actionCreators/transfers";
import { getAccountAvatars, getClubTransfers, getCurrentClubAdminAccount, getGameTransfers } from "../../../../store/selectors";
import dropdownStyles from "../../../../config/customStyles";

const TradeRecord = (props) => {

  const { t } = useTranslation();const dispatch = useDispatch();
  const transferList = useSelector(getClubTransfers);
  const gameTransferList = useSelector(getGameTransfers);
  const { id: clubId } = useParams();
  const { isMember } = props.location || {};
  const adminAccount = useSelector(getCurrentClubAdminAccount);
  const avatarList = useSelector(getAccountAvatars);
  const [search, setSearch] = useState('');
  const calendar = Calendar.useCalendar();
  const [selectedDate, selectDate] = useState({ value: 'last24Hour', label: t('last24Hour') });

  const transferTypes = [
    { value: 'transfers', label: t('transfers') },
    { value: 'gameTransfers', label: t('gameTransfers') }
  ];

  const dateOptions = useMemo(() => [
    { value: 'last24Hour', label: t('last24Hour') },
    { value: 'lastWeek', label: t('lastWeek') },
    { value: 'lastMonth', label: t('lastMonth') },
    {
      value: 'customRange', label: selectedDate.value === 'customRange' ?
        (moment(calendar.since).format('DD.MM.YY') + ' - ' + moment(calendar.till).format('DD.MM.YY')) :
        t('customRange')
    },
  ], [selectedDate, calendar]);

  const [selectedRange, selectRange] = useState({
    startRange: calendar.since,
    endRange: calendar.till
  });

  const [selectedTransferType, selectTransferType] = useState(transferTypes[0]);


  const selectDateRange = useCallback((e) => {
    if (e.value === 'customRange')
      calendar.setFocusedInput(START_DATE);
    selectDate(e);
  }, [selectedDate]);

  const filteredTransfers = useMemo(() => transferList.filter(
    t => (
      !search ||
      (t.applierName.toLowerCase().includes(search.toLowerCase())) ||
      (t.playerName.toLowerCase().includes(search.toLowerCase()))
    )
  ), [transferList, search]);

  useEffect(() => {
    let startDate = null;
    let endDate = null;

    switch (selectedDate.value) {
      case 'last24Hour': {
        endDate = moment();
        startDate = moment().subtract(1, 'day');
        break;
      } case 'lastWeek': {
        endDate = moment().endOf('day');
        startDate = endDate.clone().subtract(7, 'days').startOf('day');
        break;
      } case 'lastMonth': {
        endDate = moment().endOf('day');
        startDate = endDate.clone().subtract(1, 'month').startOf('day');
        break;
      } default: {
        startDate = calendar.since.startOf('day');
        endDate = calendar.till.endOf('day');
      }
    }
    if(isMember && selectedTransferType.value === "transfers")
      dispatch(requestClubTransfers(startDate.format(), endDate.format()));
    else if (isMember && selectedTransferType.value === "gameTransfers")
      dispatch(requestGameTransfers(startDate.format(), endDate.format()))
    else
      dispatch(requestClubTransfers());
  }, [selectedDate, calendar, selectedTransferType]);


  const onChangeSearch = useCallback(e => {
    setSearch(e.target.value);
  }, []);

  return (
    <div className={`tradeRecord`}>
      { isMember && <Header title={`tradeRecords`} to={`/club/${clubId}`} />}
      { !isMember &&
        <div className={`searchMember`}>
          <input onChange={onChangeSearch} />
          <span className={'searchIcon'}></span>
        </div>
      }
      { !!isMember &&
        <React.Fragment>
          <div className={`filtersContainer`}>
            <div className={`filterWrapper`}>
              <span>{t('type')}</span>
              <Dropdown options={transferTypes} selected={selectedTransferType} onChange={(e) => selectTransferType(e)} styles={dropdownStyles.gameTypeSelectorStyles} />
            </div>
            <div className={`filterWrapper`}>
              <span>{t('date')}</span>
              <Dropdown options={dateOptions} selected={selectedDate} onChange={(e) => selectDateRange(e)} styles={dropdownStyles.gameTypeSelectorStyles} />
            </div>
          </div>
          <Calendar.Body {...calendar} currentRange={selectedRange} hideInputs />
        </React.Fragment>
      }
      <div className={`memberList`}>
        { (selectedTransferType.value !== "gameTransfers" || !isMember) &&
          filteredTransfers.map(player =>
            <PlayerRow
              type={isMember ? '' : 'tradeRecord'}
              key={player.date}
              player={player}
              avatar={avatarList[adminAccount && adminAccount.id === player.applierId && adminAccount.typeId === 2 ? adminAccount.clubAccountId : player.applierId]}
            />
          )
        }
        { selectedTransferType.value === "gameTransfers" &&
          gameTransferList.map((transfer, index) => 
            <GameTransferRow transfer={transfer} key={index} />
          )
        }
      </div>
    </div>
  );
};

export default TradeRecord;
